import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase project: PakMazar (pakmazar-prod), web app "PakMazar Admin".
export const firebaseConfig = {
  apiKey: 'AIzaSyB2LLMI9FRoA9pfb7OnmN-1FoQcVrPZvF0',
  authDomain: 'pakmazar-prod.firebaseapp.com',
  projectId: 'pakmazar-prod',
  storageBucket: 'pakmazar-prod.firebasestorage.app',
  messagingSenderId: '476495585871',
  appId: '1:476495585871:web:848e10fe5d4c30e65d003a',
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// PakMazar Functions are deployed in europe-west1.
export const functions = getFunctions(app, 'europe-west1');

export default app;